// Test IDs for the reusable first-time guided-tour engine (GuidedTour.jsx)
// and the per-page "Replay Tour" testing trigger. Generic — not tied to any
// one page — so the same keys apply everywhere a tour is mounted (login,
// dashboard, poems, ...). See ./auth.js for the naming directive.

export const TOUR = {
	overlay: 'tour-overlay',
	tooltip: 'tour-tooltip',
	nextButton: 'tour-next-button',
	backButton: 'tour-back-button',
	skipButton: 'tour-skip-button',
	finishButton: 'tour-finish-button',
	replayButton: 'tour-replay-button',
};
